import {Component, OnInit} from '@angular/core';
import {FormComponent} from '@ngx-ivengi/crud';
import {DrawingService} from './drawing.service';
import {UIRouter} from '@uirouter/angular';
import {Drawing} from './drawing.model';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import {FileService} from '../file/file.service';

@Component({
  selector: 'app-drawing-form',
  templateUrl: './drawing-form.component.html'
})
export class DrawingFormComponent extends FormComponent implements OnInit {
  public drawing: Drawing = new Drawing();
  public formTitle: string;
  public stateIdParam: string = 'drawingId';

  constructor(
    protected router: UIRouter,
    private drawingService: DrawingService,
    private translate: TranslateService,
    private fileService: FileService
  ) {
    super(router);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.translate.get('drawing.form.add.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });
      } break;

      case this.FormMode.UPDATE: {
        this.drawingService.setRoutePrefix(`building/${this.router.stateService.params.buildingId}/floor/${this.router.stateService.params.floorId}`);
        this.translate.get('drawing.form.update.blockTitle').subscribe((translation) => {
          this.formTitle = translation;
        });

        this.drawingService.get(this.router.stateService.params[this.stateIdParam]).map((drawing) => {
          drawing.setFileSrc(this.fileService.getLinkById(drawing.fileId));
          return drawing;
        }).subscribe((drawing) => {
          this.drawing = drawing;
        });
      } break;
    }
  }

  public fileChange(evt) {
    this.drawing.setFile(evt.target.files);
  }

  public save(): void {
    switch(this.formMode) {
      case this.FormMode.ADD: {
        this.drawingService.add(this.drawing).subscribe((result) => {
          this.router.stateService.go('building.edit.floor.edit', this.router.stateService.params, {reload: true});
        });
      } break;

      case this.FormMode.UPDATE: {
        this.drawingService.update(this.drawing).subscribe((result) => {
          this.router.stateService.go('building.edit.floor.edit', this.router.stateService.params, {reload: true});
        });
      } break;
    }

  }

}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/drawing/drawing-form.component.ts